const SERVICE = 'case-service'

const getAdminConsultationsListApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/admin/case', params)

const getAdminConsultationApi = async (api, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/admin/case/${id}`)

const createAdminConsultationApi = async (api, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/admin/case')

const updateAdminConsultationApi = async (api, id, body) => api
  .setMethod()
  .put()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/case/${id}`)

const deleteAdminConsultationApi = async (api, id) => api
  .setMethod()
  .delete()
  .setService(SERVICE)
  .process(`/admin/case/${id}`)

const updateStatusAdminConsultationApi = async (api, id, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process(`/admin/case/${id}/status`)

const getConsultationsListApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/case', params)

const getAvailableConsultationsListApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/status', params)

const postConsultationApi = async (api, body) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process('/case')

const getConsultationsHistoryListApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/user', params)

const getConsultationHistoryDetailsApi = async (api, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/case/${id}`)

const assignDocToConsultationApi = async (api, id) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .process(`/doctor/${id}/assign`)

const getDoctorConsultationsHistoryListApi = async (api, params = {}) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/doctor', params)

const getDoctorConsultationHistoryDetailsApi = async (api, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/doctor/${id}`)

const getPatientConsultationRecordApi = async (api, params = {}, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/doctor/user/${id}`, params)

const setConsultationPreferenceApi = async (api, id, body) => api
  .setMethod()
  .put()
  .setBody(body)
  .setService(SERVICE)
  .process(`/case/${id}`)

const postDoctorNotesApi = async (api, body, params = {}, consultationId) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process(`/doctor/${consultationId}/note`, params)

const postDoctorMCApi = async (api, body, params = {}, id) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process(`/doctor/${id}/mc`, params)

const postDoctorReferralApi = async (api, body, params = {}, id) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process(`/doctor/${id}/referral`, params)

const endDoctorConsultationApi = async (api, body, params = {}, consultationId) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process(`/doctor/${consultationId}/status`, params)

const audioCallRequestByDoctorApi = async (api, params = {}, consultationId) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .process(`/doctor/${consultationId}/call`, params)

const getDoctorTwilioTokensApi = async api => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process('/doctor/twilio/token')

const postDocConsultationTimeLapsedApi = async (api, body, params = {}, id) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process(`/doctor/${id}/timelapsed`, params)

const postDoctorMCNewLinkApi = async (api, params = {}, id) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .process(`/case/${id}/mc`, params)

const postDoctorReferralNewLinkApi = async (api, params = {}, id) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .process(`/case/${id}/referral`, params)

const getPatientConsultationStatusApi = async (api, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/case/${id}/status`)

const verifyTransactionAmountApi = async (api, id) => api
  .setMethod()
  .get()
  .setService(SERVICE)
  .process(`/payment/${id}`)

const getPrescriptionIdApi = async (api, body, params = {}, id) => api
  .setMethod()
  .post()
  .setService(SERVICE)
  .setBody(body)
  .process(`/doctor/${id}/prescription`, params)

const postRegenerateAgoraTokenApi = async (api, body, consultationId) => api
  .setMethod()
  .post()
  .setBody(body)
  .setService(SERVICE)
  .process(`/doctor/${consultationId}/token-regenerate`)

module.exports = {
  getAdminConsultationsListApi,
  getAdminConsultationApi,
  createAdminConsultationApi,
  updateAdminConsultationApi,
  deleteAdminConsultationApi,
  updateStatusAdminConsultationApi,

  getConsultationsListApi,
  postConsultationApi,
  getConsultationsHistoryListApi,
  getConsultationHistoryDetailsApi,
  getDoctorConsultationsHistoryListApi,
  getDoctorConsultationHistoryDetailsApi,
  getAvailableConsultationsListApi,
  assignDocToConsultationApi,
  setConsultationPreferenceApi,
  getPatientConsultationRecordApi,
  postDoctorNotesApi,
  postDoctorMCApi,
  postDoctorReferralApi,
  endDoctorConsultationApi,
  audioCallRequestByDoctorApi,
  getDoctorTwilioTokensApi,
  postDocConsultationTimeLapsedApi,
  postDoctorMCNewLinkApi,
  postDoctorReferralNewLinkApi,
  getPatientConsultationStatusApi,
  verifyTransactionAmountApi,
  getPrescriptionIdApi,
  postRegenerateAgoraTokenApi,
}
